export const promiseCache = new Map();
export const responseCache = new Map();
export function getCache(cacheKey) {
    const buildCache = (cacheKey, cache) => ({
        clear: () => cache.delete(cacheKey),
        get: () => cache.get(cacheKey),
        set: (data) => cache.set(cacheKey, data),
    });
    const promise = buildCache(cacheKey, promiseCache);
    const response = buildCache(cacheKey, responseCache);
    return {
        clear: () => {
            promise.clear();
            response.clear();
        },
        promise,
        response,
    };
}
export async function withCache(fn, { cacheKey, maxAge = Infinity }) {
    const cache = getCache(cacheKey);
    const response = cache.response.get();
    if (response && maxAge > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < maxAge)
            return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        cache.promise.set(promise);
    }
    const data = await promise;
    cache.promise.clear();
    cache.response.set({ created: new Date(), data });
    return data;
}
//# sourceMappingURL=withCache.js.map